// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rootCss_r1rhb3dw{flex-grow:1;position:relative;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/autosuggest/AutosuggestCore.css"],"names":[],"mappings":"AAAA,kBAA6E,WAAW,CAAC,iBAAiB,CAAC","sourcesContent":[".rootCss_r1rhb3dw{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;position:relative;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
